module.exports = __webpack_public_path__ + "static/media/my_image.f04f0898.jpg";